"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTransition = void 0;
var styled_components_1 = require("styled-components");
var escapeCss_1 = __importDefault(require("../../helperFunctions/escapeCss"));
var setTransition = function (property) { return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  -webkit-transition: ", ";\n  -moz-transition: ", ";\n  -ms-transition: ", ";\n  -o-transition: ", ";\n  transition: ", ";\n"], ["\n  -webkit-transition: ", ";\n  -moz-transition: ", ";\n  -ms-transition: ", ";\n  -o-transition: ", ";\n  transition: ", ";\n"])), escapeCss_1.default(property), escapeCss_1.default(property), escapeCss_1.default(property), escapeCss_1.default(property), escapeCss_1.default(property)); };
exports.setTransition = setTransition;
var templateObject_1;
//# sourceMappingURL=transition.js.map